<div class="pt-box">
  <div class="pt-text">
    <h4 class="pt-title">{{title}}</h4>
    <div class="pt-desc" *ngIf="desc">{{desc}}</div>
  </div>
  <nav class="pt-crumb" aria-label="Breadcrumb">
    <a routerLink="/dashboard" class="pt-home">Home</a>
    <span class="pt-sep">/</span>
    <span class="pt-current">{{title}}</span>
  </nav>
</div>
